import Iconify from 'src/components/Iconify';
import {
  BannersRoutes,
  CategoriesRoutes,
  HomePagesRoutes,
  PagesRoutes,
  PostsRoutes,
  TagRoutes,
} from '../Routes';
import { ICONS } from './navIcons';

export const contentEditorNavConfig = [
  {
    subheader: 'general',
    items: [{ title: 'Home', path: HomePagesRoutes.contentEditorHomePage, icon: ICONS.dashboard }],
  },
  {
    subheader: 'CMS',
    items: [
      {
        title: 'Akcije',
        path: BannersRoutes.index,
        icon: ICONS.cart,
      },
      {
        title: 'Objave',
        path: PostsRoutes.index,
        icon: ICONS.blog,
      },
      {
        title: 'Kategorije',
        path: CategoriesRoutes.index,
        icon: ICONS.menuItem,
      },
      {
        title: 'Stranice',
        path: PagesRoutes.index,
        icon: <Iconify icon={'fluent:document-one-page-24-filled'} />,
      },
      {
        title: 'Tagovi',
        path: TagRoutes.index,
        icon: <Iconify icon={'ant-design:tags-outlined'} />,
      },
    ],
  },
];
